import { pickBy } from 'lodash';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

const REQUEST_TYPE_ALIAS_NAME = 'action';

const correctRequestTypeValue = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const useQueryValues = () => {
  const location = useLocation();
  const fields = pickBy(queryString.parse(location.search), value => typeof value === 'string') as Record<
    string,
    string
  >;

  return {
    queryValues: {
      ...fields,
      requestType: fields[REQUEST_TYPE_ALIAS_NAME] && correctRequestTypeValue(fields[REQUEST_TYPE_ALIAS_NAME]),
    },
    disabledFields: {
      originalRequestId: fields['originalRequestId'],
    },
  } as {
    queryValues: Record<string, string>;
    disabledFields: Record<string, string>;
  };
};
